export const secondsToMinSec = (seconds) => {
  return new Date(seconds * 1000).toISOString().substring(14, 19)
}

export const checkValidEmail = (email) => {
  const emailRegx = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
  return email.match(emailRegx)
}